<template>
  <div class="behavior-summary-wrap">
    <Widgest isOpenAll widgestType="outer" :isBig="true">
      <template v-slot:title>{{$t('report.analyse.summary.title')}}</template>
      <SandTab v-if="tabData.length" :data="tabData" :defaultName="defaultName" @change="handleTabChange"></SandTab>
      <SandTableCollapse2
        :data="collapseData"
        @change="handleCollapseChange"
        class="behavior-summary-collapse"
      >
        <div class="behavior-event-filter">
          <SearchSelectInput
            :types="selectInputOptions"
            class="filter-input"
            v-model="baseQuery"
            @change="lazyRequest"
            @enter="getSearchChange"
          />
          <div>
            <Pagination
              @handleSizeChange="handleSizeChange"
              @handleCurrentChange="handleCurrentChange"
              :totalSize="totalSize"
              :current_page="currentPage"
              :hide_pageSize="true"
              :jumper="true"
            />
          </div>
        </div>
        <template v-if="!events || events.length === 0">
          <div class="behavior-event-wrap">
            <sandNoData :text="$t('no_result_found')" />
          </div>
        </template>
        <template v-else>
          <div class="behavior-event-wrap" ref="eventWrap">
            <div
              class="behavior-event-item"
              v-for="(item, index) in events"
              :key="index"
            >
              <div class="behavior-event-left">
                <span class="event-name">{{ getEventNameLabel(item.event) }}</span>
              </div>
              <div class="behavior-event-right">
                <div class="behavior-event-right_mainkey" v-if="item.mainkey">
                  {{ item.mainkey }}
                </div>
                <div class="behavior-event-right_actions" v-if="item.mainkey">
                  <el-tooltip class="item" :effect="$isDark() ? 'dark' : 'light'" :content="$t('action.show_detail')" placement="top">
                    <el-icon class="el-icon--tickets" @click="handleCellIconClick(item)">
                      <Tickets />
                    </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </template>
      </SandTableCollapse2>
    </Widgest>
  </div>
</template>

<script>
// 分析概览中 行为总览 模块
import sandNoData from '@/components/report/sandNoData'
import SandTab from '@/components/report/sandTab'
import SandTableCollapse2 from '@/components/report/sandTableCollapse2'
import { getTaskReportBehaviorEventsByPid, getTaskReportBehaviorEventnames } from 'services/report'
import eventDesc from '@/assets/markdown/event_description.json'
import Pagination from '@/components/common/Pagination'
import { t } from 'app/i18n'
import { debounce } from 'lodash'
import { Tickets } from '@element-plus/icons-vue'
import emitter from 'app/emitter'

export default {
  name: 'BehaviorSummary',
  components: {
    SandTab,
    SandTableCollapse2,
    sandNoData,
    Pagination,
    Tickets
  },
  props: {
    progressanalyse: {
      type: Object
    },
    taskid: {
      type: Number
    }
  },
  computed: {
    tabData() {
      // 如果后端没有返回每个类型的数量, 则使用固定的tab表头
      if (this.progressanalyse.tab_data) {
        return this.progressanalyse.tab_data.map((item) => {
          return {
            label: `${item.name} (${item.value})`,
            name: item.key
          }
        })
      }
      return []
    },
    defaultName() {
      return this.progressanalyse.tab_data ? this.progressanalyse.tab_data[0].key : 'file'
    },
    processes() {
      return this.progressanalyse.processes || []
    },
    collapseData() {
      const hasDataProcess = this.processes.filter(
        (processItem) => {
          const matchedEvent = processItem.events_info.find(events => events.key === this.eventType)
          return matchedEvent && matchedEvent.value
        }
      )
      const collapseData = hasDataProcess.map((item) => ({
        process: `${item.process_name} (${t('report.analyse.summary.process_id')}: ${item.pid})`,
        id: item.pid
      }))
      return {
        collapseData,
        columnData: [
          {
            prop: 'process',
            label: t('report.analyse.summary.process_name'),
            width: undefined,
            align: 'left',
            headAlign: 'left'
          }
        ],
        tableProps: {
          stripe: false,
          showHeader: false
        }
      }
    },
    taskId() {
      return this.$route.params.taskId || this.taskid
    },
    selectInputOptions({ eventNames }) {
      return [
        {
          value: 'event_name',
          label: t('report.analyse.summary.search_event_name.title'),
          placeholder: t('report.analyse.summary.search_event_name.placeholder'),
          type: 'select',
          mode: 'multiple',
          options: eventNames
        },
        {
          value: 'mainkey',
          label: t('report.analyse.summary.search_event_key.title'),
          placeholder: t('report.analyse.summary.search_event_key.placeholder'),
          type: 'input'
        }
      ]
    },
    queryParams({ baseQuery }) {
      const { type, value } = baseQuery
      const isArrayValue = Array.isArray(value)
      if (!value || (isArrayValue && value.length === 0)) return {}

      return { [type]: isArrayValue ? value.join(',') : value }
    }
  },
  data() {
    this.lazyRequest = debounce(this.getSearchChange, 300)
    return {
      eventList: eventDesc.event,
      eventType: this.progressanalyse.tab_data ? this.progressanalyse.tab_data[0].key : 'file',
      pid: '',
      events: [],
      baseQuery: { type: 'event_name', value: undefined },
      totalSize: 0,
      currentPage: 1,
      eventNames: [],
      eventRequestToken: 0,
      eventNameRequestToken: 0
    }
  },
  watch: {
    eventType() {
      this.requestEventInfo()
    },
    pid() {
      this.requestEventInfo()
    },
    progressanalyse: {
      handler() {
        this.eventType = this.progressanalyse.tab_data ? this.progressanalyse.tab_data[0].key : 'file'
      },
      deep: true
    }
  },
  methods: {
    getEventNameLabel(eventName) {
      const eventInfo = this.eventList[eventName]
      if (!eventInfo) return eventName
      return this.$isZh() ? (eventInfo.zhcn || eventName) : (eventInfo.enus || eventName)
    },
    handleTabChange(tab) {
      if (typeof tab === 'string') {
        this.currentPage = 1
        this.baseQuery = { type: 'event_name', value: undefined }
        this.eventType = tab
      }
    },
    requestEventInfo() {
      this.getEventById()
      this.getEventNames()
    },
    async getEventById() {
      if (!this.pid) {
        this.events = []
        this.totalSize = 0
        return
      }

      const currentToken = this.eventRequestToken + 1
      this.eventRequestToken = currentToken

      try {
        const res = await getTaskReportBehaviorEventsByPid({
          taskid: this.taskId,
          pid: this.pid,
          eventType: this.eventType,
          page: this.currentPage,
          ...this.queryParams
        })

        if (currentToken !== this.eventRequestToken) return

        this.events = (res.events && res.events[this.eventType]) || []
        this.totalSize = res.count || 0
      } catch (error) {
        if (currentToken !== this.eventRequestToken) return
        this.events = []
        this.totalSize = 0
      }

      if (this.$refs.eventWrap) {
        this.$refs.eventWrap.scrollTo({ top: 0 })
      }
    },
    handleCollapseChange(item) {
      if (item && !item.id) return
      this.currentPage = 1
      item && (this.pid = item.id)
    },
    handleSizeChange(size) {},
    handleCurrentChange(page) {
      this.currentPage = page
      this.getEventById()
    },
    getSearchChange() {
      this.currentPage = 1
      this.getEventById()
    },
    async getEventNames() {
      if (!this.pid) {
        this.eventNames = []
        return
      }

      const currentToken = this.eventNameRequestToken + 1
      this.eventNameRequestToken = currentToken

      try {
        const result = await getTaskReportBehaviorEventnames(this.taskId, this.pid, this.eventType)
        if (currentToken !== this.eventNameRequestToken) return
        this.eventNames = result
      } catch (error) {
        if (currentToken !== this.eventNameRequestToken) return
        this.eventNames = []
      }
    },
    handleCellIconClick(data) {
      const params = {
        query: this.queryParams,
        page: this.currentPage,
        basic: {
          eventType: this.eventType,
          taskId: this.taskId,
          pid: this.pid
        },
        data
      }
      this.$store.commit('report/SET_BEHAVIOR_DETAIL', params)
      emitter.emit('tabChange', 'behavior')
    }
  },
  mounted() {
    this.pid = this.processes.length > 0 && this.processes[0].pid
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';

.behavior-summary-wrap {
  .behavior-summary-collapse {
    :deep(.el-collapse) {
      border: none;
    }
    :deep(.el-collapse-item) {
      margin-bottom: 10px;
      border-bottom-width: 1px;

      .el-collapse-item__header {
        background: var(--color-bg-3);
        margin: 0;
        padding-right: 10px;
      }

      &.is-active {
        .el-collapse-item__header {
          // background: #2A3257;
        }
      }
    }

    :deep(.el-collapse-item__content) {
      border-top: 0;
      padding: 0;

      .behavior-event-android {
        padding: 20px 0;
      }

      .behavior-event-filter {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        // border-bottom: 1px solid #2D3864;

        .filter-input {
          width: 296px;
          flex: 0 0 296px;
        }
      }

      .behavior-event-wrap {
        max-height: 600px;
        @include scroll_bar();
        overflow: auto;

        .behavior-event-item {
          display: flex;
          color: var(--color-text-2);
          font-size: 14px;
          align-items: center;
          margin-bottom: 10px;
          &+.behavior-event-item {
            // border-top: 1px solid #2D3864;
          }

          .behavior-event-left {
            box-sizing: border-box;
            flex-shrink: 0;
            margin-left: 10px;
            width: 200px;
            display: flex;
            .event-name {
              display: inline-block;
              // background: #3f425180;
              background: var(--color-bg-3);
              border-radius: 2px;
              padding: 8px 12px;
              color: var(--color-text-1);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              box-sizing: border-box;
              max-width: 150px;
            }
          }

          .behavior-event-right {
            color: var(--color-text-2);
            flex: 1;
            display: flex;

            .behavior-event-right_mainkey {
              word-break: break-all;
            }
            .behavior-event-right_actions {
              margin-left: 8px;
              align-items: center;
              display: none;
              .el-icon--tickets {
                cursor: pointer;
                color: var(--color-primary);
              }
            }
          }
          &:hover {
            .behavior-event-right .behavior-event-right_actions{
              display: flex;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  :deep(.sand-tab) {
    .el-tabs__nav-wrap.is-scrollable {
      padding: 0 40px 0 30px;
    }
    .el-tabs__nav-next, .el-tabs__nav-prev {
      width: 30px;
      top: -5px;
    }
    .el-tabs__nav-prev {
      text-align: right;
    }
  }
}
</style>
